import { BaseKioskTheme } from './base/base';

export interface KioskTheme {
    name: string;
    favicon: string;
    internalBackgroundKiosk: string;
    landingPageBannerKiosk: string;
    landingPageBackgroundKiosk: string;
    kioskLogo: string;
    internalBannerMobile: string;
    landingPageBannerMobile: string;
    mobileLogo: string;
    kioskHeaderLogo?: string;
    mobileHeaderLogo?: string;
}

const mergeThemeWithBase = (theme: Partial<KioskTheme>) => {
    return {
        ...BaseKioskTheme,
        ...theme,
    };
};

export const KioskThemes: { [key: string]: KioskTheme; } = {
    default: BaseKioskTheme,
    classic: mergeThemeWithBase({
        name: 'classic',
        favicon: '/assets/img/theme/classic/favicon.ico',
        internalBackgroundKiosk: '/assets/img/theme/classic/Internal-Bkgd-Kiosk-GoMoto.jpg',
        landingPageBannerKiosk: '/assets/img/theme/classic/LP-Banner-Kiosk-GoMoto-Classic.jpg',
        landingPageBackgroundKiosk: '/assets/img/theme/classic/LP-Bkgd-Kiosk-Classic.png',
        internalBannerMobile: '/assets/img/theme/classic/Internal-Banner-Mobile-GoMoto-Classic.jpg',
        landingPageBannerMobile: '/assets/img/theme/classic/LP-Banner-Mobile-GoMoto-Classic.jpg',
        kioskLogo: '/assets/img/theme/classic/GoMoto-Logo-Kiosk.png',
        mobileLogo: '/assets/img/theme/classic/GoMoto-Logo-Mobile.png',
    }),
    acura: mergeThemeWithBase({
        name: 'acura',
        favicon: '/assets/img/theme/acura/Fav-Icon-Acura.png',
        internalBackgroundKiosk: '/assets/img/theme/acura/Internal-Bkgd-Kiosk-Acura.png',
        landingPageBannerKiosk: '/assets/img/theme/acura/LP-Banner-Kiosk-Acura.jpg',
        landingPageBackgroundKiosk: '/assets/img/theme/acura/LP-Bkgd-Kiosk-Acura.png',
        internalBannerMobile: '/assets/img/theme/acura/Internal-Banner-Mobile-Acura.jpg',
        landingPageBannerMobile: '/assets/img/theme/acura/LP-Banner-Mobile-Acura.jpg',
        kioskLogo: '/assets/img/theme/acura/OEM-Logo-Kiosk-Acura-Body.svg',
        mobileLogo: '/assets/img/theme/acura/OEM-Logo-Kiosk-Acura-Body.svg',
        kioskHeaderLogo: '/assets/img/theme/acura/OEM-Logo-Kiosk-Acura-Header.svg',
        mobileHeaderLogo: '/assets/img/theme/acura/OEM-Logo-Kiosk-Acura-Header.svg',
    }),
    audi: mergeThemeWithBase({
        name: 'audi',
        favicon: '/assets/img/theme/audi/Fav-Icon-Audi.png',
        internalBackgroundKiosk: '/assets/img/theme/audi/Internal-Bkgd-Kiosk-Audi.png',
        landingPageBannerKiosk: '/assets/img/theme/audi/LP-Banner-Kiosk-Audi.jpg',
        landingPageBackgroundKiosk: '/assets/img/theme/audi/LP-Bkgd-Kiosk-Audi.png',
        internalBannerMobile: '/assets/img/theme/audi/Internal-Banner-Mobile-Audi.jpg',
        landingPageBannerMobile: '/assets/img/theme/audi/LP-Banner-Mobile-Audi.jpg',
        kioskLogo: '/assets/img/theme/audi/OEM-Logo-Kiosk-Audi.png',
        mobileLogo: '/assets/img/theme/audi/OEM-Logo-Kiosk-Audi-Header.png',
        kioskHeaderLogo: '/assets/img/theme/audi/OEM-Logo-Kiosk-Audi-Header.png',
    }),
    bmw: mergeThemeWithBase({
        name: 'bmw',
        favicon: '/assets/img/theme/bmw/Fav-Icon-BMW.png',
        internalBackgroundKiosk: '/assets/img/theme/bmw/Internal-Bkgd-Kiosk-BMW.png',
        landingPageBannerKiosk: '/assets/img/theme/bmw/LP-Banner-Kiosk-BMW.jpg',
        landingPageBackgroundKiosk: '/assets/img/theme/bmw/LP-Bkgd-Kiosk-BMW.png',
        internalBannerMobile: '/assets/img/theme/bmw/Internal-Banner-Mobile-BMW.jpg',
        landingPageBannerMobile: '/assets/img/theme/bmw/LP-Banner-Mobile-BMW.jpg',
        kioskLogo: '/assets/img/theme/bmw/OEM-Logo-Kiosk-BMW.png',
        mobileLogo: '/assets/img/theme/bmw/OEM-Logo-Mobile-BMW.png',
        kioskHeaderLogo: '/assets/img/theme/bmw/OEM-Logo-Kiosk-BMW-Header.png',
        mobileHeaderLogo: '/assets/img/theme/bmw/OEM-Logo-Mobile-Header-BMW.png',
    }),
    buick: mergeThemeWithBase({
        name: 'buick',
        favicon: '/assets/img/theme/buick/Fav-Icon-Buick.png',
        internalBackgroundKiosk: '/assets/img/theme/buick/Internal-Bkgd-Kiosk-Buick.png',
        landingPageBannerKiosk: '/assets/img/theme/buick/LP-Banner-Kiosk-Buick.jpg',
        landingPageBackgroundKiosk: '/assets/img/theme/buick/LP-Bkgd-Kiosk-Buick.png',
        internalBannerMobile: '/assets/img/theme/buick/Internal-Banner-Mobile-Buick.jpg',
        landingPageBannerMobile: '/assets/img/theme/buick/LP-Banner-Mobile-Buick.jpg',
        kioskLogo: '/assets/img/theme/buick/OEM-Logo-Kiosk-Buick.png',
        mobileLogo: '/assets/img/theme/buick/OEM-Logo-Mobile-Buick.png',
        kioskHeaderLogo: '/assets/img/theme/buick/OEM-Logo-Kiosk-Buick-Header.png',
        mobileHeaderLogo: '/assets/img/theme/buick/OEM-Logo-Kiosk-Buick-Header.png',
    }),
    cadillac: mergeThemeWithBase({
        name: 'cadillac',
        favicon: '/assets/img/theme/cadillac/Fav-Icon-Cadillac.png',
        internalBackgroundKiosk: '/assets/img/theme/cadillac/Internal-Bkgd-Kiosk-Cadillac.png',
        landingPageBannerKiosk: '/assets/img/theme/cadillac/LP-Banner-Kiosk-Cadillac.jpg',
        landingPageBackgroundKiosk: '/assets/img/theme/cadillac/LP-Bkgd-Kiosk-Cadillac.png',
        internalBannerMobile: '/assets/img/theme/cadillac/Internal-Banner-Mobile-Cadillac.jpg',
        landingPageBannerMobile: '/assets/img/theme/cadillac/LP-Banner-Mobile-Cadillac.jpg',
        kioskLogo: '/assets/img/theme/cadillac/OEM-Logo-Kiosk-Cadillac.png',
        mobileLogo: '/assets/img/theme/cadillac/OEM-Logo-Mobile-Cadillac.png',
    }),
    chevrolet: mergeThemeWithBase({
        name: 'chevrolet',
        favicon: '/assets/img/theme/chevrolet/Fav-Icon-Chevrolet.png',
        internalBackgroundKiosk: '/assets/img/theme/chevrolet/Internal-Bkgd-Kiosk-Chevrolet.png',
        landingPageBannerKiosk: '/assets/img/theme/chevrolet/LP-Banner-Kiosk-Chevrolet.jpg',
        landingPageBackgroundKiosk: '/assets/img/theme/chevrolet/LP-Bkgd-Kiosk-Chevrolet.png',
        internalBannerMobile: '/assets/img/theme/chevrolet/Internal-Banner-Mobile-Chevrolet.jpg',
        landingPageBannerMobile: '/assets/img/theme/chevrolet/LP-Banner-Mobile-Chevrolet.jpg',
        kioskLogo: '/assets/img/theme/chevrolet/OEM-Logo-Kiosk-Chevrolet.png',
        mobileLogo: '/assets/img/theme/chevrolet/OEM-Logo-Mobile-Chevrolet.png',
    }),
    chrysler: mergeThemeWithBase({
        name: 'chrysler',
        favicon: '/assets/img/theme/chrysler/Fav-Icon-Chrysler.png',
        internalBackgroundKiosk: '/assets/img/theme/chrysler/Internal-Bkgd-Kiosk-Chrysler.jpg',
        landingPageBannerKiosk: '/assets/img/theme/chrysler/LP-Banner-Kiosk-Chrysler.jpg',
        landingPageBackgroundKiosk: '/assets/img/theme/chrysler/LP-Bkgd-Kiosk-Chrysler.png',
        internalBannerMobile: '/assets/img/theme/chrysler/Internal-Banner-Mobile-Chrysler.jpg',
        landingPageBannerMobile: '/assets/img/theme/chrysler/LP-Banner-Mobile-Chrysler.jpg',
        kioskLogo: '/assets/img/theme/chrysler/OEM-Logo-Kiosk-Chrysler.png',
        mobileLogo: '/assets/img/theme/chrysler/OEM-Logo-Mobile-Chrysler.png',
    }),
    cjdr: mergeThemeWithBase({
        name: 'cjdr',
        internalBackgroundKiosk: '/assets/img/theme/cjdr/Internal-Bkgd-Kiosk-CJDR.jpg',
        landingPageBannerKiosk: '/assets/img/theme/cjdr/LP-Banner-Kiosk-CJDR.jpg',
        landingPageBackgroundKiosk: '/assets/img/theme/cjdr/LP-Bkgd-Kiosk-CJDR.png',
        internalBannerMobile: '/assets/img/theme/cjdr/Internal-Banner-Mobile-CJDR.jpg',
        landingPageBannerMobile: '/assets/img/theme/cjdr/LP-Banner-Mobile-CJDR.jpg',
        kioskLogo: '/assets/img/theme/cjdr/OEM-Logo-Kiosk-CJDR.png',
        mobileLogo: '/assets/img/theme/cjdr/OEM-Logo-Mobile-CJDR.png',
    }),
    dodge: mergeThemeWithBase({
        name: 'dodge',
        favicon: '/assets/img/theme/dodge/Fav-Icon-Dodge.png',
        internalBackgroundKiosk: '/assets/img/theme/dodge/Internal-Bkgd-Kiosk-Dodge.jpg',
        landingPageBannerKiosk: '/assets/img/theme/dodge/LP-Banner-Kiosk-Dodge.jpg',
        landingPageBackgroundKiosk: '/assets/img/theme/dodge/LP-Bkgd-Kiosk-Dodge.png',
        internalBannerMobile: '/assets/img/theme/dodge/Internal-Banner-Mobile-Dodge.jpg',
        landingPageBannerMobile: '/assets/img/theme/dodge/LP-Banner-Mobile-Dodge.jpg',
        kioskLogo: '/assets/img/theme/dodge/OEM-Logo-Kiosk-Dodge.png',
        mobileLogo: '/assets/img/theme/dodge/OEM-Logo-Mobile-Dodge.png',
    }),
    ford: mergeThemeWithBase({
        name: 'ford',
        favicon: '/assets/img/theme/ford/Fav-Icon-Ford.png',
        internalBackgroundKiosk: '/assets/img/theme/ford/Internal-Bkgd-Kiosk-Ford.png',
        landingPageBannerKiosk: '/assets/img/theme/ford/LP-Banner-Kiosk-Ford.jpg',
        landingPageBackgroundKiosk: '/assets/img/theme/ford/LP-Bkgd-Kiosk-Ford.png',
        internalBannerMobile: '/assets/img/theme/ford/Internal-Banner-Mobile-Ford.jpg',
        landingPageBannerMobile: '/assets/img/theme/ford/LP-Banner-Mobile-Ford.jpg',
        kioskLogo: '/assets/img/theme/ford/OEM-Logo-Kiosk-Ford.png',
        mobileLogo: '/assets/img/theme/ford/OEM-Logo-Mobile-Ford.png',
        kioskHeaderLogo: '/assets/img/theme/ford/OEM-Logo-Kiosk-Ford-Header.png',
    }),
    generic: mergeThemeWithBase({
        name: 'generic',
        internalBackgroundKiosk: '/assets/img/theme/generic/Landing-Page-Background-Generic.png',
        landingPageBannerKiosk: '/assets/img/theme/generic/Landing-Page-Banner-Generic.jpg',
        landingPageBackgroundKiosk: '/assets/img/theme/generic/Landing-Page-Background-Generic.png',
        internalBannerMobile: '/assets/img/theme/generic/Internal-Page-Banner-Mobile-Generic.jpg',
        landingPageBannerMobile: '/assets/img/theme/generic/Landing-Page-Banner-Mobile-Generic.jpg',
        kioskLogo: '/assets/img/theme/generic/Logo-Kiosk-KeyTrak-Header.svg',
        mobileLogo: '/assets/img/theme/generic/Logo-Kiosk-KeyTrak-Header.svg',
    }),
    genesis: mergeThemeWithBase({
        name: 'genesis',
        favicon: '/assets/img/theme/genesis/Fav-Icon-Genesis.png',
        internalBackgroundKiosk: '/assets/img/theme/genesis/Internal-Bkgd-Kiosk-Genesis.png',
        landingPageBannerKiosk: '/assets/img/theme/genesis/LP-Banner-Kiosk-Genesis.jpg',
        landingPageBackgroundKiosk: '/assets/img/theme/genesis/LP-Bkgd-Kiosk-Genesis.png',
        internalBannerMobile: '/assets/img/theme/genesis/Internal-Banner-Mobile-Genesis.jpg',
        landingPageBannerMobile: '/assets/img/theme/genesis/LP-Banner-Mobile-Genesis.jpg',
        kioskLogo: '/assets/img/theme/genesis/OEM-Logo-Kiosk-Genesis-body.svg',
        mobileLogo: '/assets/img/theme/genesis/OEM-Logo-Kiosk-Genesis-body.svg',
        kioskHeaderLogo: '/assets/img/theme/genesis/OEM-Logo-Kiosk-Genesis-Header.svg',
        mobileHeaderLogo: '/assets/img/theme/genesis/OEM-Logo-Kiosk-Genesis-Header.svg',
    }),
    gm: mergeThemeWithBase({
        name: 'gm',
        favicon: '/assets/img/theme/gm/Fav-Icon-GM.png',
        internalBackgroundKiosk: '/assets/img/theme/gm/Internal-Bkgd-Kiosk-GM.jpg',
        landingPageBannerKiosk: '/assets/img/theme/gm/LP-Banner-Kiosk-GM.jpg',
        landingPageBackgroundKiosk: '/assets/img/theme/gm/LP-Bkgd-Kiosk-GM.png',
        internalBannerMobile: '/assets/img/theme/gm/Internal-Banner-Mobile-GM.jpg',
        landingPageBannerMobile: '/assets/img/theme/gm/LP-Banner-Mobile-GM.jpg',
        kioskLogo: '/assets/img/theme/gm/OEM-Logo-Kiosk-GM.png',
        mobileLogo: '/assets/img/theme/gm/OEM-Logo-Mobile-GM.png',
    }),
    gmc: mergeThemeWithBase({
        name: 'gmc',
        favicon: '/assets/img/theme/gmc/Fav-Icon-GMC.png',
        internalBackgroundKiosk: '/assets/img/theme/gmc/Internal-Bkgd-Kiosk-GMC.png',
        landingPageBannerKiosk: '/assets/img/theme/gmc/LP-Banner-Kiosk-GMC.jpg',
        landingPageBackgroundKiosk: '/assets/img/theme/gmc/LP-Bkgd-Kiosk-GMC.png',
        internalBannerMobile: '/assets/img/theme/gmc/Internal-Banner-Mobile-GMC.jpg',
        landingPageBannerMobile: '/assets/img/theme/gmc/LP-Banner-Mobile-GMC.jpg',
        kioskLogo: '/assets/img/theme/gmc/OEM-Logo-Kiosk-GMC.png',
        mobileLogo: '/assets/img/theme/gmc/OEM-Logo-Mobile-GMC.png',
    }),
    honda: mergeThemeWithBase({
        name: 'honda',
        favicon: '/assets/img/theme/honda/Fav-Icon-Honda.png',
        internalBackgroundKiosk: '/assets/img/theme/honda/Internal-Bkgd-Kiosk-Honda.png',
        landingPageBannerKiosk: '/assets/img/theme/honda/LP-Banner-Kiosk-Honda.jpg',
        landingPageBackgroundKiosk: '/assets/img/theme/honda/LP-Bkgd-Kiosk-Honda.png',
        internalBannerMobile: '/assets/img/theme/honda/Internal-Banner-Mobile-Honda.jpg',
        landingPageBannerMobile: '/assets/img/theme/honda/LP-Banner-Mobile-Honda.jpg',
        kioskLogo: '/assets/img/theme/honda/OEM-Logo-Kiosk-Honda-Body.svg',
        mobileLogo: '/assets/img/theme/honda/OEM-Logo-Mobile-Honda.svg',
        kioskHeaderLogo: '/assets/img/theme/honda/OEM-Logo-Kiosk-Honda-Header.svg',
        mobileHeaderLogo: '/assets/img/theme/honda/OEM-Logo-Kiosk-Honda-Header.svg',
    }),
    hondacanada: mergeThemeWithBase({
        name: 'hondacanada',
        favicon: '/assets/img/theme/hondacanada/Favicon-Honda-Canada-BLK.jpg',
        internalBackgroundKiosk: '/assets/img/theme/hondacanada/Internal-Bkgd-Kiosk-HondaCa.png',
        landingPageBannerKiosk: '/assets/img/theme/hondacanada/LP-Banner-Kiosk-HondaCa.jpg',
        landingPageBackgroundKiosk: '/assets/img/theme/hondacanada/Internal-Bkgd-Kiosk-HondaCa.png',
        internalBannerMobile: '/assets/img/theme/hondacanada/Internal-Banner-Mobile-HondaCa.jpg',
        landingPageBannerMobile: '/assets/img/theme/hondacanada/LP-Banner-Mobile-HondaCa.jpg',
        kioskLogo: '/assets/img/theme/hondacanada/Logo-HondaCanada-WHT-RedBG.jpg',
        mobileLogo: '/assets/img/theme/hondacanada/Logo-HondaCa-Mobile.png',
        kioskHeaderLogo: '/assets/img/theme/hondacanada/Logo-HondaCa-Kiosk.png',
    }),
    hyundai: mergeThemeWithBase({
        name: 'hyundai',
        favicon: '/assets/img/theme/hyundai/Fav-Icon-Hyundai.png',
        internalBackgroundKiosk: '/assets/img/theme/hyundai/Internal-Bkgd-Kiosk-Hyundai.png',
        landingPageBannerKiosk: '/assets/img/theme/hyundai/LP-Banner-Kiosk-Hyundai.jpg',
        landingPageBackgroundKiosk: '/assets/img/theme/hyundai/LP-Bkgd-Kiosk-Hyundai.png',
        internalBannerMobile: '/assets/img/theme/hyundai/Internal-Banner-Mobile-Hyundai.jpg',
        landingPageBannerMobile: '/assets/img/theme/hyundai/LP-Banner-Mobile-Hyundai.jpg',
        kioskLogo: '/assets/img/theme/hyundai/OEM-Logo-Kiosk-Hyundai-Body.svg',
        mobileLogo: '/assets/img/theme/hyundai/OEM-Logo-Mobile-Hyundai.svg',
        kioskHeaderLogo: '/assets/img/theme/hyundai/OEM-Logo-Kiosk-Hyundai-Header.svg',
        mobileHeaderLogo: '/assets/img/theme/hyundai/OEM-Logo-Kiosk-Hyundai-Header.svg',
    }),
    infiniti: mergeThemeWithBase({
        name: 'infiniti',
        favicon: '/assets/img/theme/infiniti/Fav-Icon-INFINITI.png',
        internalBackgroundKiosk: '/assets/img/theme/infiniti/Internal-Bkgd-Kiosk-INFINITI.png',
        landingPageBannerKiosk: '/assets/img/theme/infiniti/LP-Banner-Kiosk-INFINITI.jpg',
        landingPageBackgroundKiosk: '/assets/img/theme/infiniti/LP-Bkgd-Kiosk-INFINITI.png',
        internalBannerMobile: '/assets/img/theme/infiniti/Internal-Banner-Mobile-INFINITI.jpg',
        landingPageBannerMobile: '/assets/img/theme/infiniti/LP-Banner-Mobile-INFINITI.jpg',
        kioskLogo: '/assets/img/theme/infiniti/infiniti_body_logo.png',
        mobileLogo: '/assets/img/theme/infiniti/infiniti_body_logo.png',
        kioskHeaderLogo: '/assets/img/theme/infiniti/infiniti_header_logo.png',
        mobileHeaderLogo: '/assets/img/theme/infiniti/infiniti_header_logo.png',
    }),
    jaguar: mergeThemeWithBase({
        name: 'jaguar',
        favicon: '/assets/img/theme/jaguar/Fav-Icon-Jaguar.png',
        internalBackgroundKiosk: '/assets/img/theme/jaguar/Internal-Bkgd-Kiosk-Jaguar.png',
        landingPageBannerKiosk: '/assets/img/theme/jaguar/LP-Banner-Kiosk-Jaguar.jpg',
        landingPageBackgroundKiosk: '/assets/img/theme/jaguar/LP-Bkgd-Kiosk-Jaguar.png',
        internalBannerMobile: '/assets/img/theme/jaguar/Internal-Banner-Mobile-Jaguar.jpg',
        landingPageBannerMobile: '/assets/img/theme/jaguar/LP-Banner-Mobile-Jaguar.jpg',
        kioskLogo: '/assets/img/theme/jaguar/OEM-Logo-Kiosk-Jaguar.png',
        mobileLogo: '/assets/img/theme/jaguar/OEM-Logo-Mobile-Jaguar.png',
    }),
    jeep: mergeThemeWithBase({
        name: 'jeep',
        favicon: '/assets/img/theme/jeep/Fav-Icon-Jeep.png',
        internalBackgroundKiosk: '/assets/img/theme/jeep/Internal-Bkgd-Kiosk-Jeep.jpg',
        landingPageBannerKiosk: '/assets/img/theme/jeep/LP-Banner-Kiosk-Jeep.jpg',
        landingPageBackgroundKiosk: '/assets/img/theme/jeep/LP-Bkgd-Kiosk-Jeep.png',
        internalBannerMobile: '/assets/img/theme/jeep/Internal-Banner-Mobile-Jeep.jpg',
        landingPageBannerMobile: '/assets/img/theme/jeep/LP-Banner-Mobile-Jeep.jpg',
        kioskLogo: '/assets/img/theme/jeep/OEM-Logo-Kiosk-Jeep.png',
        mobileLogo: '/assets/img/theme/jeep/OEM-Logo-Mobile-Jeep.png',
    }),
    keytrak: mergeThemeWithBase({
        name: 'keytrak',
        favicon: '/assets/img/theme/keytrak/Fav-Icon-KeyTrak.png',
        internalBackgroundKiosk: '/assets/img/theme/keytrak/Internal-Page-Background-KeyTrak.png',
        landingPageBannerKiosk: '/assets/img/theme/keytrak/Landing-Page-Banner-KeyTrak.jpg',
        landingPageBackgroundKiosk: '/assets/img/theme/keytrak/Landing-Page-Background-KeyTrak.png',
        internalBannerMobile: '/assets/img/theme/keytrak/Internal-Page-Banner-Mobile-KeyTrak.jpg',
        landingPageBannerMobile: '/assets/img/theme/keytrak/Landing-Page-Banner-Mobile-KeyTrak.jpg',
        kioskLogo: '/assets/img/theme/keytrak/OEM-Logo-Kiosk-KeyTrak.png',
        mobileLogo: '/assets/img/theme/keytrak/OEM-Logo-Mobile-KeyTrak.png',
        kioskHeaderLogo: '/assets/img/theme/keytrak/OEM-Logo-Kiosk-Header-KeyTrak.png',
        mobileHeaderLogo: '/assets/img/theme/keytrak/OEM-Logo-Mobile-Header-KeyTrak.png',
    }),
    kia: mergeThemeWithBase({
        name: 'kia',
        favicon: '/assets/img/theme/kia/Fav-Icon-Kia.png',
        internalBackgroundKiosk: '/assets/img/theme/kia/Internal-Bkgd-Kiosk-Kia.png',
        landingPageBannerKiosk: '/assets/img/theme/kia/LP-Banner-Kiosk-Kia.jpg',
        landingPageBackgroundKiosk: '/assets/img/theme/kia/LP-Bkgd-Kiosk-Kia.png',
        internalBannerMobile: '/assets/img/theme/kia/Internal-Banner-Mobile-Kia.jpg',
        landingPageBannerMobile: '/assets/img/theme/kia/LP-Banner-Mobile-Kia.jpg',
        kioskLogo: '/assets/img/theme/kia/OEM-Logo-Kiosk-Kia.png',
        mobileLogo: '/assets/img/theme/kia/OEM-Logo-Mobile-Kia.png',
        kioskHeaderLogo: '/assets/img/theme/kia/OEM-Logo-Mobile-Kia.png',
    }),
    landrover: mergeThemeWithBase({
        name: 'landrover',
        favicon: '/assets/img/theme/landrover/Fav-Icon-LandRover.png',
        internalBackgroundKiosk: '/assets/img/theme/landrover/Internal-Bkgd-Kiosk-LandRover.png',
        landingPageBannerKiosk: '/assets/img/theme/landrover/LP-Banner-Kiosk-LandRover.jpg',
        landingPageBackgroundKiosk: '/assets/img/theme/landrover/LP-Bkgd-Kiosk-LandRover.png',
        internalBannerMobile: '/assets/img/theme/landrover/Internal-Banner-Mobile-LandRover.jpg',
        landingPageBannerMobile: '/assets/img/theme/landrover/LP-Banner-Mobile-LandRover.jpg',
        kioskLogo: '/assets/img/theme/landrover/OEM-Logo-Kiosk-LandRover.png',
        mobileLogo: '/assets/img/theme/landrover/OEM-Logo-Mobile-LandRover.png',
    }),
    lexus: mergeThemeWithBase({
        name: 'lexus',
        favicon: '/assets/img/theme/lexus/Fav-Icon-Lexus.png',
        internalBackgroundKiosk: '/assets/img/theme/lexus/Internal-Bkgd-Kiosk-Lexus.png',
        landingPageBannerKiosk: '/assets/img/theme/lexus/LP-Banner-Kiosk-Lexus.jpg',
        landingPageBackgroundKiosk: '/assets/img/theme/lexus/LP-Bkgd-Kiosk-Lexus.png',
        internalBannerMobile: '/assets/img/theme/lexus/Internal-Banner-Mobile-Lexus.jpg',
        landingPageBannerMobile: '/assets/img/theme/lexus/LP-Banner-Mobile-Lexus.jpg',
        kioskLogo: '/assets/img/theme/lexus/OEM-Logo-Kiosk-Lexus-Body.svg',
        mobileLogo: '/assets/img/theme/lexus/OEM-Logo-Mobile-Lexus.svg',
        kioskHeaderLogo: '/assets/img/theme/lexus/OEM-Logo-Kiosk-Lexus-Header.svg',
        mobileHeaderLogo: '/assets/img/theme/lexus/OEM-Logo-Kiosk-Lexus-Header.svg',
    }),
    lincoln: mergeThemeWithBase({
        name: 'lincoln',
        favicon: '/assets/img/theme/lincoln/Fav-Icon-Lincoln.png',
        internalBackgroundKiosk: '/assets/img/theme/lincoln/Internal-Bkgd-Kiosk-Lincoln.png',
        landingPageBannerKiosk: '/assets/img/theme/lincoln/LP-Banner-Kiosk-Lincoln.jpg',
        landingPageBackgroundKiosk: '/assets/img/theme/lincoln/LP-Bkgd-Kiosk-Lincoln.png',
        internalBannerMobile: '/assets/img/theme/lincoln/Internal-Banner-Mobile-Lincoln.jpg',
        landingPageBannerMobile: '/assets/img/theme/lincoln/LP-Banner-Mobile-Lincoln.jpg',
        kioskLogo: '/assets/img/theme/lincoln/OEM-Logo-Kiosk-Lincoln-body.svg',
        mobileLogo: '/assets/img/theme/lincoln/OEM-Logo-Mobile-Lincoln.svg',
        kioskHeaderLogo: '/assets/img/theme/lincoln/OEM-Logo-Kiosk-Lincoln-Header.svg',
        mobileHeaderLogo: '/assets/img/theme/lincoln/OEM-Logo-Kiosk-Lincoln-Header.svg',
    }),
    mazda: mergeThemeWithBase({
        name: 'mazda',
        favicon: '/assets/img/theme/mazda/Fav-Icon-Mazda.png',
        internalBackgroundKiosk: '/assets/img/theme/mazda/Internal-Bkgd-Kiosk-Mazda.png',
        landingPageBannerKiosk: '/assets/img/theme/mazda/LP-Banner-Kiosk-Mazda.jpg',
        landingPageBackgroundKiosk: '/assets/img/theme/mazda/LP-Bkgd-Kiosk-Mazda.png',
        internalBannerMobile: '/assets/img/theme/mazda/Internal-Banner-Mobile-Mazda.jpg',
        landingPageBannerMobile: '/assets/img/theme/mazda/LP-Banner-Mobile-Mazda.jpg',
        kioskLogo: '/assets/img/theme/mazda/OEM-Logo-Kiosk-Mazda.png',
        mobileLogo: '/assets/img/theme/mazda/OEM-Logo-Mobile-Mazda.png',
        kioskHeaderLogo: '/assets/img/theme/mazda/OEM-Logo-Kiosk-Mazda-Header.png',
    }),
    mercedesbenz: mergeThemeWithBase({
        name: 'mercedesbenz',
        favicon: '/assets/img/theme/mercedesbenz/Fav-Icon-MB.png',
        internalBackgroundKiosk: '/assets/img/theme/mercedesbenz/Internal-Bkgd-Kiosk-MercedesBenz.png',
        landingPageBannerKiosk: '/assets/img/theme/mercedesbenz/LP-Banner-Kiosk-MercedesBenz.jpg',
        landingPageBackgroundKiosk: '/assets/img/theme/mercedesbenz/LP-Bkgd-Kiosk-MercedesBenz.png',
        internalBannerMobile: '/assets/img/theme/mercedesbenz/Internal-Banner-Mobile-MercedesBenz.jpg',
        landingPageBannerMobile: '/assets/img/theme/mercedesbenz/LP-Banner-Mobile-MercedesBenz.jpg',
        kioskLogo: '/assets/img/theme/mercedesbenz/OEM-Logo-Kiosk-Body-Mercedes_Benz.svg',
        kioskHeaderLogo: '/assets/img/theme/mercedesbenz/OEM-Logo-Kiosk-Mercedes_Benz-Header.svg',
        mobileLogo: '/assets/img/theme/mercedesbenz/OEM-Logo-Mobile-Mercedes_Benz.svg',
    }),
    mini: mergeThemeWithBase({
        name: 'mini',
        favicon: '/assets/img/theme/mini/Fav-Icon-MINI.png',
        internalBackgroundKiosk: '/assets/img/theme/mini/Internal-Bkgd-Kiosk-MINI.png',
        landingPageBannerKiosk: '/assets/img/theme/mini/LP-Banner-Kiosk-MINI.jpg',
        landingPageBackgroundKiosk: '/assets/img/theme/mini/LP-Bkgd-Kiosk-MINI.png',
        internalBannerMobile: '/assets/img/theme/mini/Internal-Banner-Mobile-MINI.jpg',
        landingPageBannerMobile: '/assets/img/theme/mini/LP-Banner-Mobile-MINI.jpg',
        kioskLogo: '/assets/img/theme/mini/OEM-Logo-Kiosk-MINI.png',
        mobileLogo: '/assets/img/theme/mini/OEM-Logo-Mobile-MINI.png',
    }),
    mitsubishi: mergeThemeWithBase({
        name: 'mitsubishi',
        favicon: '/assets/img/theme/mitsubishi/Fav-Icon-Mitsubishi.png',
        internalBackgroundKiosk: '/assets/img/theme/mitsubishi/Internal-Page-Background-Mitsubishi.png',
        landingPageBannerKiosk: '/assets/img/theme/mitsubishi/Landing-Page-Banner-Mitsubishi.jpg',
        landingPageBackgroundKiosk: '/assets/img/theme/mitsubishi/Landing-Page-Background-Mitsubishi.png',
        internalBannerMobile: '/assets/img/theme/mitsubishi/Internal-Page-Banner-Mobile-Mitsubishi.jpg',
        landingPageBannerMobile: '/assets/img/theme/mitsubishi/Landing-Page-Banner-Mobile-Mitsubishi.jpg',
        kioskLogo: '/assets/img/theme/mitsubishi/OEM-Logo-Kiosk-Mitsubishi-body.png',
        mobileLogo: '/assets/img/theme/mitsubishi/OEM-Logo-Mobile-Mitsubishi.png',
        kioskHeaderLogo: '/assets/img/theme/mitsubishi/OEM-Logo-Kiosk-Mitsubishi-Header.png',
        mobileHeaderLogo: '/assets/img/theme/mitsubishi/OEM-Logo-Kiosk-Mitsubishi-Header.png',
    }),
    nissan: mergeThemeWithBase({
        name: 'nissan',
        favicon: '/assets/img/theme/nissan/Fav-Icon-Nissan.png',
        internalBackgroundKiosk: '/assets/img/theme/nissan/Internal-Bkgd-Kiosk-Nissan.png',
        landingPageBannerKiosk: '/assets/img/theme/nissan/LP-Banner-Kiosk-Nissan.jpg',
        landingPageBackgroundKiosk: '/assets/img/theme/nissan/LP-Bkgd-Kiosk-Nissan.png',
        internalBannerMobile: '/assets/img/theme/nissan/Internal-Banner-Mobile-Nissan.jpg',
        landingPageBannerMobile: '/assets/img/theme/nissan/LP-Banner-Mobile-Nissan.jpg',
        kioskLogo: '/assets/img/theme/nissan/OEM-Logo-Kiosk-Nissan-body.svg',
        mobileLogo: '/assets/img/theme/nissan/OEM-Logo-Mobile-Nissan.svg',
        kioskHeaderLogo: '/assets/img/theme/nissan/OEM-Logo-Kiosk-Nissan-Header.svg',
        mobileHeaderLogo: '/assets/img/theme/nissan/OEM-Logo-Kiosk-Nissan-Header.svg',
    }),
    porsche: mergeThemeWithBase({
        name: 'porsche',
        favicon: '/assets/img/theme/porsche/Fav-Icon-Porsche.png',
        internalBackgroundKiosk: '/assets/img/theme/porsche/Internal-Bkgd-Kiosk-Porsche.png',
        landingPageBannerKiosk: '/assets/img/theme/porsche/LP-Banner-Kiosk-Porsche.jpg',
        landingPageBackgroundKiosk: '/assets/img/theme/porsche/LP-Bkgd-Kiosk-Porsche.png',
        internalBannerMobile: '/assets/img/theme/porsche/Internal-Banner-Mobile-Porsche.jpg',
        landingPageBannerMobile: '/assets/img/theme/porsche/LP-Banner-Mobile-Porsche.jpg',
        kioskLogo: '/assets/img/theme/porsche/OEM-Logo-Kiosk-Porsche.png',
        mobileLogo: '/assets/img/theme/porsche/OEM-Logo-Kiosk-Porsche-Header.png',
        kioskHeaderLogo: '/assets/img/theme/porsche/OEM-Logo-Kiosk-Porsche-Header.png',
    }),
    ram: mergeThemeWithBase({
        name: 'ram',
        favicon: '/assets/img/theme/ram/Fav-Icon-RAM.png',
        internalBackgroundKiosk: '/assets/img/theme/ram/Internal-Bkgd-Kiosk-RAM.jpg',
        landingPageBannerKiosk: '/assets/img/theme/ram/LP-Banner-Kiosk-RAM.jpg',
        landingPageBackgroundKiosk: '/assets/img/theme/ram/LP-Bkgd-Kiosk-RAM.png',
        internalBannerMobile: '/assets/img/theme/ram/Internal-Banner-Mobile-RAM.jpg',
        landingPageBannerMobile: '/assets/img/theme/ram/LP-Banner-Mobile-RAM.jpg',
        kioskLogo: '/assets/img/theme/ram/OEM-Logo-Kiosk-RAM.png',
        mobileLogo: '/assets/img/theme/ram/OEM-Logo-Mobile-RAM.png',
    }),
    reynolds: mergeThemeWithBase({
        name: 'reynolds',
        favicon: '/assets/img/theme/reynolds/Fav-Icon-Reynolds.svg',
        internalBackgroundKiosk: '/assets/img/theme/reynolds/Internal-Page-Background-Reynolds.png',
        landingPageBannerKiosk: '/assets/img/theme/reynolds/Landing-Page-Banner-Reynolds.jpg',
        landingPageBackgroundKiosk: '/assets/img/theme/reynolds/Landing-Page-Background-Reynolds.png',
        internalBannerMobile: '/assets/img/theme/reynolds/Internal-Page-Banner-Mobile-Reynolds.jpg',
        landingPageBannerMobile: '/assets/img/theme/reynolds/Landing-Page-Banner-Mobile-Reynolds.jpg',
        kioskLogo: '/assets/img/theme/reynolds/OEM-Logo-Kiosk-Reynolds.png',
        kioskHeaderLogo: '/assets/img/theme/reynolds/OEM-Logo-Kiosk-Header-Reynolds.png',
        mobileLogo: '/assets/img/theme/reynolds/OEM-Logo-Mobile-Reynolds.png',
        mobileHeaderLogo: '/assets/img/theme/reynolds/OEM-Logo-Mobile-Header-Reynolds.png',
    }),
    subaru: mergeThemeWithBase({
        name: 'subaru',
        favicon: '/assets/img/theme/subaru/Fav-Icon-Subaru.png',
        internalBackgroundKiosk: '/assets/img/theme/subaru/Internal-Bkgd-Kiosk-Subaru.png',
        landingPageBannerKiosk: '/assets/img/theme/subaru/LP-Banner-Kiosk-Subaru.jpg',
        landingPageBackgroundKiosk: '/assets/img/theme/subaru/LP-Bkgd-Kiosk-Subaru.png',
        internalBannerMobile: '/assets/img/theme/subaru/Internal-Banner-Mobile-Subaru.jpg',
        landingPageBannerMobile: '/assets/img/theme/subaru/LP-Banner-Mobile-Subaru.jpg',
        kioskLogo: '/assets/img/theme/subaru/OEM-Logo-Kiosk-Subaru.png',
        mobileLogo: '/assets/img/theme/subaru/OEM-Logo-Mobile-Subaru.png',
    }),
    toyota: mergeThemeWithBase({
        name: 'toyota',
        favicon: '/assets/img/theme/toyota/Fav-Icon-Toyota.png',
        internalBackgroundKiosk: '/assets/img/theme/toyota/Internal-Bkgd-Kiosk-Toyota.png',
        landingPageBannerKiosk: '/assets/img/theme/toyota/LP-Banner-Kiosk-Toyota.jpg',
        landingPageBackgroundKiosk: '/assets/img/theme/toyota/LP-Bkgd-Kiosk-Toyota.png',
        internalBannerMobile: '/assets/img/theme/toyota/Internal-Banner-Mobile-Toyota.jpg',
        landingPageBannerMobile: '/assets/img/theme/toyota/LP-Banner-Mobile-Toyota.jpg',
        kioskLogo: '/assets/img/theme/toyota/OEM-Logo-Kiosk-Toyota-body.svg',
        kioskHeaderLogo: '/assets/img/theme/toyota/OEM-Logo-Kiosk-Toyota-Header.svg',
        mobileLogo: '/assets/img/theme/toyota/OEM-Logo-Mobile-Toyota.svg',
        mobileHeaderLogo: '/assets/img/theme/toyota/OEM-Logo-Kiosk-Toyota-Header.svg',
    }),
    volkswagen: mergeThemeWithBase({
        name: 'volkswagen',
        favicon: '/assets/img/theme/volkswagen/Fav-Icon-VW.png',
        internalBackgroundKiosk: '/assets/img/theme/volkswagen/Internal-Bkgd-Kiosk-VW.png',
        landingPageBannerKiosk: '/assets/img/theme/volkswagen/LP-Banner-Kiosk-VW.jpg',
        landingPageBackgroundKiosk: '/assets/img/theme/volkswagen/LP-Bkgd-Kiosk-VW.png',
        internalBannerMobile: '/assets/img/theme/volkswagen/Internal-Banner-Mobile-VW.jpg',
        landingPageBannerMobile: '/assets/img/theme/volkswagen/LP-Banner-Mobile-VW.jpg',
        kioskLogo: '/assets/img/theme/volkswagen/OEM-Logo-Kiosk-VW-body.svg',
        kioskHeaderLogo: '/assets/img/theme/volkswagen/OEM-Logo-Kiosk-VW-Header.svg',
        mobileLogo: '/assets/img/theme/volkswagen/OEM-Logo-Mobile-VW.svg',
        mobileHeaderLogo: '/assets/img/theme/volkswagen/OEM-Logo-Kiosk-VW-Header.svg',
    }),
};